module.exports = __webpack_public_path__ + "img/user-octagon.a560575e.svg";